<div ng-controller="UserController as userCtrl" class="modal-view">
    <c-auto-form config="userCtrl.autoFormConfig"></c-auto-form>
</div>
